module.exports = __webpack_public_path__ + "static/media/hall-ms624-01.0743538c.jpg";